import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { PatentDivide } from 'src/types/api/patentRightsApiTypes';
import { Table, TopItem, Title, Content } from 'src/components/contents/detail/DetailPage';

interface Iprops {
  data: PatentDivide;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 專利分割案 區塊。
 */
const InfoPatentDivide: React.FC<Iprops> = ({ data, isShow, setIsShow, colorType, noContent }) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;
  return (
    <DropdownInfo title={`專利分割案`} isShow={isShow} setIsShow={setIsShow} color={angleColor}>
      <Table color={tableColor}>
        {data.divides.map((item) => {
          return (
            <TopItem key={item.newApplyNo}>
              <Title>分割後申請案號</Title>
              <Content>{item.newApplyNo || noContent}</Content>
            </TopItem>
          );
        })}
      </Table>
    </DropdownInfo>
  );
};

export default InfoPatentDivide;
